import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-hot-toast'

import { AppButton, StickyHeaderNavigation } from '@/components'
import { BaseView, BaseText } from '@/components/base'
import { useRequestYourData } from '@/domain'
import useOffsets from '@/hooks/useOffsets'
import { requestData } from '@/assets/images'

export const RequestYourDataScreen: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const offsets = useOffsets()

  const { requestYourData, isPending: isLoadingRequestingData } =
    useRequestYourData({
      onSuccess: () => {
        toast.success(
          `${t('translation:requestData.dataSent')}. ${t('translation:requestData.yourDataWillBeSent')}`,
          {
            duration: 5000,
          },
        )
        navigate('/security', { replace: true })
      },
      onError: ({ errorMessage }) => {
        if (errorMessage) {
          toast.error(errorMessage)
        }
      },
    })

  return (
    <BaseView style={{ height: '100vh' }} className="h-full flex flex-col">
      <StickyHeaderNavigation />
      <BaseView
        style={{
          paddingTop: offsets.top + 60,
        }}
        className="flex-1 flex flex-col items-center"
        px={13}
      >
        <BaseView className="w-full" style={{ maxWidth: 400 }}>
          <img
            src={requestData}
            alt="Request Data"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              marginBottom: 24,
            }}
          />
        </BaseView>

        <BaseView className="w-full" gap={12}>
          <BaseText
            fontSize={28}
            fontFamily="semibold"
            className="text-center"
            translationKey="translation:requestData.requestData"
          />

          <BaseText
            fontSize={16}
            lineHeight={22}
            color="label.description"
            className="text-center"
          >
            {t('translation:requestData.requestZip')}
          </BaseText>
        </BaseView>
      </BaseView>

      <BaseView
        className="w-full"
        px={13}
        style={{ paddingBottom: offsets.bottom }}
      >
        <AppButton
          label={t('translation:requestData.requestMyData')}
          onClick={requestYourData}
          isLoading={isLoadingRequestingData}
        />
      </BaseView>
    </BaseView>
  )
}

export default RequestYourDataScreen
